export const BIKE_TAB = "bike_tab";
export const SITE_TAB = "site_tab";
export const VOUCHER_TAB = "voucher_tab";



// WEBPACK FOOTER //
// ./src/store/ui/types.js